export default "__VITE_ASSET__CeTj8xEQ__"